import { css, CSSObject } from '@emotion/react'
import { BreakPointKeys, BREAKPOINTS } from './constants'

type MediaQueryFunction = (
  first: TemplateStringsArray,
  ...arguments_: CSSObject[]
) => ReturnType<typeof css>

export const responsive = Object.keys(BREAKPOINTS).reduce(
  (accumulator, breakpoint) => {
    accumulator[breakpoint as BreakPointKeys] = (
      first: TemplateStringsArray,
      ...interpolations: CSSObject[]
    ) => css`
      @media (max-width: ${BREAKPOINTS[breakpoint as BreakPointKeys]}) {
        ${css(first, ...interpolations)}
      }
    `

    return accumulator
  },
  {} as Record<BreakPointKeys, MediaQueryFunction>,
)
